import { GLOBEL_CHANGE_LOADING } from '../actionTypes';

interface ActionTypes {
  type: string;
  payload: object;
}

export interface LoadingState {
  loading: boolean;
  loadText: string;
}
export type StateType = LoadingState;

const initState = {
  loading: false,
  loadText: '正在加载',
};

function reducer(state: LoadingState = initState, action: ActionTypes) {
  switch (action.type) {
    case GLOBEL_CHANGE_LOADING:
      console.log(123, action);
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
